import { apiGetWorkLog } from '@/api/designers.api'
import { errorMessage } from 'modules/Error'

function byDateDesc (a, b) {
  return b.fromTs - a.fromTs
}

export const WorkLog = {
  state: {
    workLogData: null,
    isLoading: false
  },
  mutations: {
    setWorkLogData (state, payload) {
      state.workLogData = payload;
      state.isLoading = false;
    },
    "WorkLog/setIsLoading" (state, payload) {
      state.isLoading = payload;
    }
  },
  actions: {
    async getWorkLog ({ commit }) {
      commit("WorkLog/setIsLoading", true)

      const [err, data] = await apiGetWorkLog()
      if (err) return errorMessage(err, 'Unabled to load work log!')
      return commit("setWorkLogData", [...data.items].sort(byDateDesc))
    }
  },
  getters: {
    getWorkLogData: (state) => state.workLogData,
    getCurrentPeriodAmount: (state) => state.workLogData[0].amount,
    getCurrentPeriodStartDate: (state) => state.workLogData[0].fromTs,
    getIsWorkLogDataLoading: (state) => state.isLoading,
    getAmountSum: (state) =>
      state.workLogData.reduce((acc, amount) => {
        const sum = acc + amount;
        return sum;
      }, 0)
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/WorkLog.js